export default __webpack_public_path__ + "c115ae0cb6847d55a0fa9bee782ee94e.png";